import type { GraphQLFormattedError } from 'graphql';
import type { ComposerTranslation } from 'vue-i18n';

export const SERVICE_PACKAGE_ERROR_CODE = 'service_has_service_packages';

export type ServicePackageGraphQLErrors =
  | ReadonlyArray<GraphQLFormattedError>
  | null
  | undefined;

export const isServicePackageDeletionError = (
  graphQLErrors: ServicePackageGraphQLErrors,
): boolean =>
  graphQLErrors?.some(
    (graphqlError) =>
      graphqlError.extensions?.code === SERVICE_PACKAGE_ERROR_CODE,
  ) ?? false;

const getServicePackageName = (
  graphQLErrors: ServicePackageGraphQLErrors,
): string | undefined => {
  const packageNames = graphQLErrors?.find(
    (graphqlError) =>
      graphqlError.extensions?.code === SERVICE_PACKAGE_ERROR_CODE,
  )?.extensions?.service_package_names;

  return Array.isArray(packageNames)
    ? packageNames.find(
        (packageName): packageName is string => typeof packageName === 'string',
      )
    : undefined;
};

export const servicePackageDeletionMessage = (
  t: ComposerTranslation,
  serviceName: string,
  graphQLErrors: ServicePackageGraphQLErrors,
): string => {
  const packageName = getServicePackageName(graphQLErrors);
  if (packageName) {
    return t('service.delete_blocked_by_active_service_package_with_name', {
      serviceName,
      packageName,
    });
  }

  return t('service.delete_blocked_by_active_service_package', {
    serviceName,
  });
};
